export const STATUSES_COLOR = {
    'new': '#9ece0c',
    'in progress': '#0ccebc',
    'reported': '#0f0cce',
    'closed': '#8555ce',
    'cancelled': '#ce540c'
};
